import Cookies from 'js-cookie';

/**
 * @description Получаем код страны из куки 'BITRIX_SM_location_country'
 * @returns {string}
 */
export default () => Cookies.get('BITRIX_SM_location_country');
